'use client';

import { c as _c } from "react/compiler-runtime";
import { useLayoutEffect, useState } from 'react';
export default function useScrollPosition() {
  const $ = _c(2);
  const [scrollPosition, setScrollPosition] = useState(0);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      const detectScrollPosition = function detectScrollPosition() {
        setScrollPosition(window.scrollY);
      };
      detectScrollPosition();
      window.addEventListener("scroll", detectScrollPosition);
      return () => window.removeEventListener("scroll", detectScrollPosition);
    };
    t1 = [];
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  useLayoutEffect(t0, t1);
  return scrollPosition;
}